import Route from './route';

export default Route;
